import logger from "@next/core-logger"
import {AxiosRequestHeaders} from "axios"
import {IncomingHttpHeaders} from "http"
import axios from "../../utils/axios"

import {FooterModel} from "../../models/footerModel"
import FooterApiConfig from "../../config/api/footerdata"

// this will always be called server-side on first render and subsequent server-side renders
export const getFooterData = async (headers: IncomingHttpHeaders, footerName: string): Promise<FooterModel> => {
    try {
        const getFooterDataApi = FooterApiConfig("getFooterData")
        const response = await axios({
            method: getFooterDataApi.method,
            url: `${getFooterDataApi.localEndpoint(footerName)}`,
            headers: headers as AxiosRequestHeaders,
        })

        return response.data
    } catch (error) {
        const ex = error as Error
        logger.error(ex)
        throw ex
    }
}
